import React, { useEffect, useState } from 'react'

import { useAppDispatch } from 'hooks/reduxHooks'
import { clearTemplates } from 'slices/template'
import WalletReportHeader from 'component/WalletReport/WalletReportHeader'
import WalletReportTable from 'component/WalletReport/WalletReportTable'
import { PaginationState } from 'types'

interface TempaltePageLayoutProps {
	client?: string
}

const WalletReportLayout: React.FC<TempaltePageLayoutProps> = () => {
	const dispatch = useAppDispatch()

	const [pagination, setPagination] = useState<PaginationState>({
		currentPage: 1,
		totalCount: 0,
		pageSize: 10,
	})
	useEffect(() => {
		return () => {
			dispatch(clearTemplates())
		}
	}, [])

	return (
		<>
			<WalletReportHeader pagination={pagination} />
			<WalletReportTable setPagination={setPagination} />
		</>
	)
}

WalletReportLayout.defaultProps = {
	client: undefined,
}

export default WalletReportLayout
